<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form
      autocomplete="off"
      method="post"
      @submit.prevent="addOrUpdateUserRole()"
    >
      <div class="my-card">
        <div class="row">
          <!-- <div class="form-label-group col-12">
            <b-form-select
              v-model="userRoleData.roleTypeToken"
              :options="roleTypeTokenOptions"
              class="form-control"
            ></b-form-select>
            <img src="@/assets/images/user-roles.svg" />
          </div> -->
          <CustomInput
            :className="'col-md-6'"
            :id="'UserRoleNameAr'"
            :value="userRoleData.establishmentRoleNameAr"
            :title="$t('general.role.nameAr')"
            :imgName="'user-roles.svg'"
            v-on:changeValue="userRoleData.establishmentRoleNameAr = $event"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'UserRoleNameEn'"
            :value="userRoleData.establishmentRoleNameEn"
            :title="$t('general.role.nameEn')"
            :imgName="'user-roles.svg'"
            v-on:changeValue="userRoleData.establishmentRoleNameEn = $event"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'UserRoleNameUnd'"
            :value="userRoleData.establishmentRoleNameUnd"
            :title="$t('general.role.nameUnd')"
            :imgName="'user-roles.svg'"
            v-on:changeValue="userRoleData.establishmentRoleNameUnd = $event"
          />

          <TextArea
            :className="'col-md-6'"
            :id="'UserRoleDescriptionAr'"
            :value="userRoleData.establishmentRoleDescriptionAr"
            :title="$t('general.role.descriptionAr')"
            :imgName="'description.svg'"
            v-on:changeValue="
              userRoleData.establishmentRoleDescriptionAr = $event
            "
          />
          <TextArea
            :className="'col-md-6'"
            :id="'UserRoleDescriptionEn'"
            :value="userRoleData.establishmentRoleDescriptionEn"
            :title="$t('general.role.descriptionEn')"
            :imgName="'description.svg'"
            v-on:changeValue="
              userRoleData.establishmentRoleDescriptionEn = $event
            "
          />
          <TextArea
            :className="'col-md-6'"
            :id="'UserRoleDescriptionUnd'"
            :value="userRoleData.establishmentRoleDescriptionUnd"
            :title="$t('general.role.descriptionUnd')"
            :imgName="'description.svg'"
            v-on:changeValue="
              userRoleData.establishmentRoleDescriptionUnd = $event
            "
          />
          <TextArea
            :className="'col-md-12'"
            :id="'UserRoleNotes'"
            :value="userRoleData.establishmentRoleNotes"
            :title="$t('notes')"
            :imgName="'notes.svg'"
            v-on:changeValue="userRoleData.establishmentRoleNotes = $event"
          />
          <CustomCheckbox
            :className="'col-md-12'"
            :value="userRoleData.establishmentRoleDefaultStatus"
            v-on:changeValue="
              userRoleData.establishmentRoleDefaultStatus = $event
            "
            :title="$t('general.role.default')"
          />
        </div>
      </div>

      <div class="form-footer">
        <button name="submit" type="submit" class="btn btn-submit">
          {{ submitName }}
        </button>
        <router-link
          :to="`/settings/settings-other/${userRoleData.userType}-roles`"
          class="btn btn-cancel"
        >
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import CustomInput from "@/components/general/CustomInput.vue";
import TextArea from "@/components/general/TextArea.vue";
import CustomCheckbox from "@/components/general/CustomCheckbox.vue";

import { mapGetters } from "vuex";

export default {
  name: "UserRoleForm",
  components: {
    PreLoader,
    ExceptionWithImg,
    CustomInput,
    TextArea,
    CustomCheckbox,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      roleTypeTokenOptions: [],
    };
  },
  props: ["userRoleData", "submitName"],
  computed: {
    ...mapGetters(["userData"]),
  },
  methods: {
    async getroleTypesList() {
      // this.isLoading = true;
      this.roleTypeTokenOptions = [];
      this.roleTypeTokenOptions.push({
        value: "",
        text: this.$t("general.role.select"),
      });
      try {
        const itemsData =
          this.$store.getters.userData.constantsLists.listRoleTypeData;
        if (itemsData.length > 0) {
          for (let item in itemsData) {
            this.roleTypeTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text:
                this.language == "en"
                  ? itemsData[item]["itemNameEn"]
                  : itemsData[item]["itemNameAr"],
            });
          }
        } else {
          this.roleTypeTokenOptions = [];
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.showMsg(this.$t("errorCatch"));
        this.roleTypeTokenOptions = null;
      }
      this.isLoading = false;
    },
    async addOrUpdateUserRole() {
      this.$emit("addOrUpdateUserRole");
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      if (lang == "en") return dataEn;
      else return dataAr;
    },
  },
  watch: {},
  async created() {
    this.getroleTypesList();
  },
};
</script>

<style lang="scss"></style>
